import { inject, InjectionToken, Signal, signal } from '@angular/core';

/**
 * Opções visuais do mapa societário que as visões internas (grafo, geo, matriz, controle,
 * estrutura) precisam ler sem receber input por input. O `app-registry-network-card` se provê
 * neste token; usadas fora dele (sem provedor), as visões ficam no padrão de Deals.
 */
export interface OwnershipNetworkDisplay {
  /** Pinta a empresa consultada com a cor e o raio próprios (verde, maior). */
  readonly highlightRoot: Signal<boolean>;
  /** Mostra o selo "Possível holding" nas visões Controle e Estrutura. */
  readonly showHoldingBadge: Signal<boolean>;
}

export const OWNERSHIP_NETWORK_DISPLAY = new InjectionToken<OwnershipNetworkDisplay>(
  'OWNERSHIP_NETWORK_DISPLAY'
);

const PADRAO: OwnershipNetworkDisplay = {
  highlightRoot: signal(true).asReadonly(),
  showHoldingBadge: signal(true).asReadonly(),
};

/** Lê as opções do card mais próximo, ou o padrão de Deals quando não há card acima. */
export function injectOwnershipNetworkDisplay(): OwnershipNetworkDisplay {
  return inject(OWNERSHIP_NETWORK_DISPLAY, { optional: true }) ?? PADRAO;
}
